import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import IndustriesSection from './components/IndustriesSection';
import LeadershipSection from './components/LeadershipSection';
import OperatingModelSection from './components/OperatingModelSection';
import CTASection from './components/CTASection';
import { useEffect } from 'react';

const HomePage = () => {
  useEffect(() => {
    document.title = 'MACGOC | Enterprise Consulting Across Technology, Healthcare, Logistics, Fuel Retail & Finance';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'MACGOC delivers strategic advisory and operational excellence across technology, healthcare, logistics, fuel retail, and finance through U.S.-registered entities. Transform operations and achieve sustainable growth.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'business consulting, enterprise consulting, technology consulting, healthcare consulting, logistics consulting, fuel retail consulting, capital advisory, MACGOC');
    }
  }, []);

  return (
    <div className="min-h-screen bg-black">
      <Navigation />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <IndustriesSection />
        <LeadershipSection />
        <OperatingModelSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
